// Stub for react-native-device-info.
// The real package is not used in the web app, but it is imported transitively
// through galarm-shared. Its web build tries to call navigator.getBattery() and
// attach event listeners, which fails in some browsers with:
//   TypeError: e.addEventListener is not a function
// This stub provides the subset of synchronous getters that galarm-shared actually
// calls on the web code path, all returning safe placeholder values.
const DeviceInfo = {
  getModel: () => 'Web',
  getSystemName: () => 'Web',
  getSystemVersion: () => '',
  getDeviceId: () => '',
  getBrand: () => '',
  getBundleId: () => '',
  getVersion: () => '',
  getBuildNumber: () => ''
}

export default DeviceInfo
